// @ts-check
import { all } from 'redux-saga/effects';

import payersSaga from 'shared/sagas/PayersSaga';
import referralDashboardSaga from 'shared/sagas/ReferralDashboardSaga';
import flashMessagesSaga from 'shared/sagas/FlashMessagesSaga';
import referralTypeSelectionSaga from './ReferralTypeSelectionSaga';

export default function* rootSaga() {
  yield all([
    payersSaga(),
    referralDashboardSaga(),
    flashMessagesSaga(),
    referralTypeSelectionSaga(),
  ]);
}
